import React, { useState, useEffect } from "react";
import MenuComponent from "./Menu.component";
import { useLocation } from "react-router-dom";
import { fetchHubMenuCountInfo, fetchMenuCountInfo, fetchNotReadMessageCount } from "api/agency/v2/menu.api";

const MenuContainer = (props: any) => {
  const location = useLocation();
  const [showMessageBadge, setShowMessageBadge] = useState(false);
  const [showHubBadge, setShowHubBadge] = useState(false);

  const [showNoticeBadge, setShowNoticeBadge] = useState(false);

  useEffect(() => {
    if ((location.pathname == '/agency' || location.pathname == '/agency/message' || location.pathname == '/agency/search')) {
      getMenuCountInfo();
      const interval = setInterval(() => {
        getMenuCountInfo();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [location]);

  const getMenuCountInfo = async () => {
    try {
      const data = await fetchMenuCountInfo();
      console.log({ data });
      setShowMessageBadge(data.notReadMessageCount > 0);
      setShowHubBadge(data.newNoticeCount > 0);
    } catch (error) {
      console.error("메뉴 카운트 정보 조회 실패:", error);
      setShowMessageBadge(false);
      setShowHubBadge(false);
    }
  };


  useEffect(() => {
    if (location.pathname.startsWith('/agency/hub')) {
      getHubMenuCountInfo();
      const interval = setInterval(() => {
        getHubMenuCountInfo();
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [location]);

  const getHubMenuCountInfo = async () => {
    try {
      const data = await fetchHubMenuCountInfo();
      console.log({ data });
      setShowNoticeBadge(data.newNoticeCount > 0);
    } catch (error) {
      console.error("메뉴 카운트 정보 조회 실패:", error);
      setShowNoticeBadge(false);
    }
  };

  return <MenuComponent
    showMessageBadge={showMessageBadge}
    showHubBadge={showHubBadge}

    showNoticeBadge={showNoticeBadge} />;
};

export default MenuContainer;